import { Component, EventEmitter, inject, Input, OnDestroy, Output } from '@angular/core';
import { LocatePackage, LocatePackageData } from '../../../modules/teams/interfaces/locate-package';
import { LoadPdfTemplatesComponent } from './load-pdf-templates/load-pdf-templates.component';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'mee-locate-package',
  templateUrl: './locate-package.component.html',
  styleUrls: ['./locate-package.component.scss'],
})
export class LocatePackageComponent implements OnDestroy {
  private _locatePackage: LocatePackageData = {
    CoverPagesUrl: '',
    MainPageUrl: '',
    TrailingPagesUrl: '',
    Bottom: null,
    Top: null,
    Side: null
  };
  private destroy$: Subject<void> = new Subject();
  private readonly matDialog = inject(MatLegacyDialog);

  @Output() locatePackageChange = new EventEmitter<LocatePackageData>();

  @Input() set locatePackage(locatePackage: LocatePackage) {
    if (locatePackage) {
      this._locatePackage = locatePackage;

      return;
    }

    this._locatePackage = null;
  }

  get isHasTemplates(): boolean {
    return (
      this._locatePackage &&
      Boolean(this._locatePackage.CoverPagesUrl) &&
      Boolean(this._locatePackage.MainPageUrl) &&
      Boolean(this._locatePackage.TrailingPagesUrl)
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openLoadPdfDialog(): void {
    this.matDialog
      .open<LoadPdfTemplatesComponent, LocatePackageData, LocatePackageData>(LoadPdfTemplatesComponent, {
        data: this._locatePackage,
        width: '392px',
        autoFocus: false,
      })
      .afterClosed()
      .pipe(
        filter(data => !!data),
        tap(locatePackageUrls => {
          this._locatePackage = { ...this._locatePackage, ...locatePackageUrls };
          this.locatePackageChange.emit(this._locatePackage);
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
